"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractKitProvider = exports.useInternalContractKit = exports.useContractKit = void 0;
var react_1 = __importStar(require("react"));
var unstated_next_1 = require("unstated-next");
var constants_1 = require("./constants");
var modals_1 = require("./modals");
var useConnectorConfig_1 = require("./utils/useConnectorConfig");
var DEFAULT_KIT_STATE = {
    networks: constants_1.DEFAULT_NETWORKS,
    dapp: {
        name: 'Celo dApp',
        description: 'Celo dApp',
        url: 'https://celo.org',
    },
};
var useKit = function (_a) {
    var _b;
    var _c = _a === void 0 ? DEFAULT_KIT_STATE : _a, _d = _c.networks, networks = _d === void 0 ? constants_1.DEFAULT_NETWORKS : _d, dappInput = _c.dapp;
    var dapp = react_1.useState({
        name: dappInput.name,
        description: dappInput.description,
        icon: (_b = dappInput.icon) !== null && _b !== void 0 ? _b : dappInput.url + "/favicon.ico",
        url: dappInput.url,
    })[0];
    var connectorConfig = useConnectorConfig_1.useConnectorConfig({ networks: networks });
    var _e = react_1.useState(0), pendingActionCount = _e[0], setPendingActionCount = _e[1];
    // Initialisation error state management
    var _f = react_1.useState(null), initError = _f[0], setInitError = _f[1];
    var initConnector = react_1.useCallback(function (nextConnector) { return __awaiter(void 0, void 0, void 0, function () {
        var connector_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, nextConnector.initialise()];
                case 1:
                    connector_1 = _a.sent();
                    setInitError(null);
                    return [2 /*return*/, { connector: connector_1, error: null }];
                case 2:
                    e_1 = _a.sent();
                    console.error('[use-contractkit] Error initializing connector', nextConnector.type, e_1);
                    setInitError(e_1);
                    return [2 /*return*/, { connector: null, error: e_1 }];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var connector = connectorConfig.connector, connect = connectorConfig.connect;
    var getConnectedKit = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var initialisedConnection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initialisedConnection = connector;
                    if (!(connector.type === constants_1.WalletTypes.Unauthenticated)) return [3 /*break*/, 2];
                    return [4 /*yield*/, connect()];
                case 1:
                    initialisedConnection = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!!initialisedConnection.initialised) return [3 /*break*/, 4];
                    return [4 /*yield*/, initConnector(initialisedConnection)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, initialisedConnection.kit];
            }
        });
    }); }, [connect, connector, initConnector]);
    var performActions = react_1.useCallback(function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var kit, results, _a, operations_1, op, _b, _c, e_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, getConnectedKit()];
                    case 1:
                        kit = _d.sent();
                        setPendingActionCount(operations.length);
                        results = [];
                        _a = 0, operations_1 = operations;
                        _d.label = 2;
                    case 2:
                        if (!(_a < operations_1.length)) return [3 /*break*/, 8];
                        op = operations_1[_a];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        _c = (_b = results).push;
                        return [4 /*yield*/, op(kit)];
                    case 4:
                        _c.apply(_b, [_d.sent()]);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _d.sent();
                        setPendingActionCount(0);
                        throw e_2;
                    case 6:
                        setPendingActionCount(function (c) { return c - 1; });
                        _d.label = 7;
                    case 7:
                        _a++;
                        return [3 /*break*/, 2];
                    case 8: return [2 /*return*/, results];
                }
            });
        });
    }, [getConnectedKit]);
    return __assign(__assign({}, connectorConfig), { dapp: dapp, kit: connector.kit, walletType: connector.type, account: connector.account, initialised: connector.initialised, performActions: performActions, getConnectedKit: getConnectedKit, initError: initError, 
        // private
        initConnector: initConnector, pendingActionCount: pendingActionCount });
};
var KitState = unstated_next_1.createContainer(useKit);
exports.useContractKit = KitState.useContainer;
/**
 * UseContractKit with internal methods exposed. Package use only.
 */
exports.useInternalContractKit = KitState.useContainer;
var ContractKitProvider = function (_a) {
    var children = _a.children, connectModal = _a.connectModal, actionModal = _a.actionModal, dapp = _a.dapp, networks = _a.networks;
    return (react_1.default.createElement(KitState.Provider, { initialState: { networks: networks, dapp: dapp } },
        react_1.default.createElement(modals_1.ConnectModal, __assign({}, connectModal)),
        react_1.default.createElement(modals_1.ActionModal, __assign({}, actionModal)),
        children));
};
exports.ContractKitProvider = ContractKitProvider;
//# sourceMappingURL=use-contractkit.js.map